<template>
  <v-form>
    <v-container>
      <v-row>
        <v-col cols="12">
          <p class="body-2">このサイトは確定申告をする際におおよその所得税額を計算することができるサイトです。<br>令和2年度税制改正に対応しています。</p>
          <p class="body-2">小規模企業共済や確定拠出年金の掛金を任意で入力できるので、いくら掛ければ所得に対してどの程度の節税になるか等、簡易的なシュミレーションにもお使いいただけます。<br>所得金額に対する個人事業税の計算もできます。</p>
          <p class="body-2">サイト内の説明及び計算された金額は正しさを保証するものではありません。<br>税金に関するご質問は各自治体の最寄りの税務署までお問い合わせください。</p>
          <p class="body-2">その他、当サイトに関してのお問い合わせは下記までお願いいたします。</p>
          <p><a href="https://ji-develop.com/blog/お問い合わせ" target="_blank" rel="noopener noreferrer">お問い合わせ</a></p>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
  export default {
    name: 'about-page',
  }
</script>
